import React from "react";
import "../Clients/Clients.css";
import { motion } from "framer-motion";

function Clients() {

  const clients_name=["Medisol Lab","Medisol Lab","Medisol Lab","Medisol Lab","Medisol Lab"];

  return (
    <>
      <motion.div initial={{ opacity:0  }} transition={{ ease: "easeIn", duration: 2 }} whileInView={{ opacity:1 }} className="clients">
        <h2>
          Our Clients
          <hr />
        </h2>
        <p>
        We are delighted to have worked with many wonderful clients and feel privileged to be a part of their mission to provide quality healthcare products worldwide!
        </p>


        <div className="clients-container">
          <div className="clients-container-row">
            {clients_name.map((item,index)=>(
              <div className="clients-container-card" key={index}>
                <p className="clients-container-card-text">{item}</p>
              </div>
            ))}
          </div>


          {/* <div className="clients-container-row">
            <div className="clients-container-card">
              <p className="clients-container-card-text">Medisol Lab</p>
            </div>
            <div className="clients-container-card">
              <p className="clients-container-card-text">Medisol Lab</p>
            </div>
            <div className="clients-container-card">
              <p className="clients-container-card-text">Medisol Lab</p>
            </div>
            <div className="clients-container-card">
              <p className="clients-container-card-text">Medisol Lab</p>
            </div>
          </div> */}

          {/* <div className="clients-container-row">
            <div className="clients-container-card">
              <p className="clients-container-card-text">Medisol Lab</p>
            </div>
            <div className="clients-container-card">
              <p className="clients-container-card-text">Medisol Lab</p>
            </div>
            <div className="clients-container-card">
              <p className="clients-container-card-text">Medisol Lab</p>
            </div>
            <div className="clients-container-card">
              <p className="clients-container-card-text">Medisol Lab</p>
            </div>
          </div> */}
        </div>
      </motion.div>
    </>
  );
}
export default Clients;
